import { request, GST_API_URL, getAuthToken } from './axiosInstance';
import axios from 'axios';

// Get GST for cart items + pincode
export async function getGSTByCartAndPincode({ cartItems, pincode }) {
  try {
    const token = await getAuthToken();

    const payload = {
      pincode,
      items: cartItems.map(item => ({
  product_id: item.id,
  quantity: item.quantity || 1,
  price: Number(item.price || item.sale_price || item.regular_price || 0)
}))

    };

    const response = await axios.post(GST_API_URL, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response.data; // { gst: number }

  } catch (error) {
    console.error(
      'Error fetching GST:',
      error.response?.data || error.message
    );
    throw new Error('Failed to fetch GST');
  }
}
